module.exports = __webpack_public_path__ + "img/UP_carburant.f1591f84.jpg";